/* eslint-disable multiline-comment-style */
/* eslint-disable no-unused-vars */
// import core & vendor packages below
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form, FormControl, Button, Tabs, Tab, Image } from 'react-bootstrap';

// import components below
import ViewRecord from './ViewRecord';
import TabsUI from 'components/UI/TabsUI';
import AttendanceTable from './AttendanceTable';
import ConditionalRender from 'components/ConditionalRender';
import { TableFiltersPermission, checkStringPermission } from 'helpers/filteredPermissions';
import { showUsers, getACLState, getRoles, getDepartments, getLogs } from 'reducers/aclReducer';

// import assets below
import './index.scss';
import logoImage from 'assets/images/strh.png';
import { ReactComponent as PlusSVG } from 'assets/svg/circle-plus-blue.svg';

// main component
const LeaveContainer = () => {
  const [showScreen, setShowScreen] = useState(1);
  const [requestData, setRequestData] = useState();
  const [userData, setUserData] = useState({ triggered: false, fromDate:'', toDate:'', searchEmployee:'' });

  const handleChange = (key) => (e) => {
    setUserData({
      ...userData,
      [key]: e.target.value,
    });
  };

  const handleSubmit = () => {
    setUserData({
      ...userData,
      triggered: true,
    });
  };

  const searchEmployee = (key) => (e) => {
    setUserData({
      ...userData,
      [key]: e.target.value,
      triggered: true,
    });
  };

  return (
    <>
      {/* Default View */}
      <ConditionalRender
        condition={showScreen === 1}
        renderIf={
          <div className='advances-container shadow-sm'>
            <div className='box-container blue'>
              <Form.Group className='inline-group'>
                <Form.Label className='label'>ATTENDANCE LOGS</Form.Label>

                <FormControl className='blue-control' placeholder='Search Employee' onChange={searchEmployee('searchEmployee')} />
              </Form.Group>
            </div>

            <div className='box-container justify-content-start'>
              <Image className='website-logo' src={logoImage} />

              <Form.Group className='employee-detail'>
                <p>DETAILS HERE</p>
                <span>Company Address</span>
              </Form.Group>

              <Form.Group className='employee-detail'>
                <p>JOHN DOE</p>
                <span>Department Manager</span>
              </Form.Group>
            </div>

            <hr />

            <div className='box-container py-0'>
              <div className='header'>
                <h2>Display Logs</h2>

                <div className='functions'>
                  <Form.Group className='inline-group'>
                    <Form.Label>From:</Form.Label>

                    <FormControl type='date' className='seven' placeholder='Enter Here' value={userData.fromDate} onChange={handleChange('fromDate')} />
                  </Form.Group>

                  <Form.Group className='inline-group'>
                    <Form.Label>To:</Form.Label>

                    <FormControl type='date' className='seven' placeholder='Enter Here' value={userData.toDate} onChange={handleChange('toDate')} />
                  </Form.Group>

                  <Button className='filter' onClick={handleSubmit}>
                    {/* <UploadSVG /> */}
                    Apply Filter
                  </Button>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className='box-container pt-0 px-0'>
              <AttendanceTable setShowScreen={setShowScreen} setRequestData={setRequestData} userData={userData} setUserData={setUserData} />
            </div>
          </div>
        }
      />

      {/* View Record */}
      <ConditionalRender
        condition={showScreen === 2}
        renderIf={<ViewRecord requestData={requestData} setShowScreen={setShowScreen} />}
      />
    </>
  );
};

export default LeaveContainer;
